import { defineStore } from 'pinia'
import {computed, ref, watch} from "vue";
import {useApiCall} from "@/composables/useApiCall.ts";
import type {DefaultError} from "@/types/api/httpError";
import {getMutexApiCall} from "@/api/mutex.ts";
import {useRoute} from "vue-router";
import type {Mutex, MutexResponse} from "@/types/mutex.ts";

export const useMutexStore = defineStore('mutex', () => {
  const mutex = ref<Mutex[]>([])
  const route = useRoute()
  const {
    isLoading: isMutexLoading,
    data: dataMutex,
    executeApiCall: mutexAction,
    error: mutexError,
  } = useApiCall<MutexResponse, DefaultError>(
    getMutexApiCall,
    true,
  )

  const getMutex = async () => {
    try {
      await mutexAction()
      if (dataMutex.value && dataMutex.value.data) {
        mutex.value = dataMutex.value.data
      }
    } catch {
      console.error(mutexError.value)
    }
  }

  const isLoading = computed(() => isMutexLoading.value)

  watch(() => [route.params, route.name],
    async () => {
      await getMutex()
    }, {deep: true})

  return {
    mutex,
    isLoading,
  }
})
